export default "__VITE_PUBLIC_ASSET__d9c4e67a__"